<template>
    <div>
        <div class="d-sm-down-none">
            <CRow>
                <CCol sm="6" style="background-size: cover; display: flex; align-items: center; justify-content: center; min-height: 100vh;" class="bg-white">
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div>
                            <h3 class="custom-32px-500 font-color-171717 text-left">Verification</h3>
                            <p class="custom-18px-500">Please enter the code we just sent to <span class="font-color-928AFD"> {{ email }} </span></p>
                        </div>
    
                        <div v-if="ErrorLogin" class="">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <CCol md="12" class="text-center mt-3 d-none d-sm-block" style="width: 100%; background-size: cover; margin: auto;">
                                           
                                            <div class="verification-input">
                                                <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code"/> <span class="custom-48px-400 font-color-101010  mr-2">-</span>
                                                <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code"/> <span class="custom-48px-400 font-color-101010 mr-2">-</span>
                                                <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code"/> <span class="custom-48px-400 font-color-101010 mr-2">-</span>
                                                <input v-model="code[3]" maxlength="1" style="width:20%" @change="submitVerification" class="custom-code" />
                                            </div>
                                        </CCol>
                                        <!-- Column for mobile view -->
                                        <CCol xs="12" class="text-center mt-3 d-sm-none" style="width: 100%; background-size: cover; margin: auto;">
                                         
                                            <div class="verification-input">
                                                <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                                <input v-model="code[3]" maxlength="1" style="width:20%" class="custom-code" />
                                            </div>
                                        </CCol>
                                        <div style="clear:both"></div>
                                    <div class="text-center mt-5">
                                        <span v-if="lblProcess === true" class="font-color-101010 custom-16px-500">Processing....</span>
                                        <br />  <br />
                                        <span class="custom-border-purple p-2 text-center text-white" v-on:click="submitVerification">
                                                            <label class="ml-2 mr-2">Continue</label></span>
                                        <br />
                                    </div>
                      
    
    
    
    
    
                    </CContainer>
                </CCol>
    
                <CCol sm="6" lg="6" 
       style="background-size: cover; background-position: center; min-height: 100vh;" 
       :style="{ backgroundImage: `url(${backgroundUrl})` }">
                <CRow class="mt-3 p-3">
                    <CCol sm="6">
                        <img src="../assets/img/Logo(1).png" height="32" alt="Interviewrr.ai company logo"/> <span class="custom-20px-500 text-white">Interviewrr</span>
                    </CCol>
                    <CCol sm="6"></CCol>
                    <CCol sm="12">
                        <h3 class="custom-32px-700 text-white mt-5">Effortless e-Voucher Distribution</h3> 
                        <p class="custom-18px-400 text-white">Easily generate and send personalized e-Vouchers automatically, encouraging customer engagement and repeat business with every interaction</p>
                    </CCol>
                </CRow>
                </CCol>
    
            </CRow>
    
        </div>

        <div style="background-color: white; min-height: 100vh; padding-bottom: 20px;" class="d-md-none d-lg-none">
            <CContainer class="otp-container">
                <CButton color="link" class="back-button" @click="$router.go(-1)">
                    <CIcon name="cil-arrow-left" size="xl" />
                </CButton>

                <!-- Page Title -->
                <h2 class="title">Enter OTP</h2>

                <div class="mt-5 text-left">
                    <h2 class="enter-otp">Enter OTP</h2>
                    <p class="mb-1" style="color:#6b7280">
                    Enter OTP Code sent to {{ maskedEmail }}
                    </p>
                    <p class="mb-4" style="color:#6b7280">
                    This code will expire in <span style="color:#ef4444">{{ mm }}:{{ ss }}</span>
                    </p>
                </div>
                

                <div class="otp-row">
                <input v-model="code[0]" maxlength="1" class="otp-box" @input="focusNext(0,$event)" @paste.prevent="onPaste($event)">
                <span class="dash">-</span>
                <input v-model="code[1]" maxlength="1" class="otp-box" @input="focusNext(1,$event)">
                <span class="dash">-</span>
                <input v-model="code[2]" maxlength="1" class="otp-box" @input="focusNext(2,$event)">
                <span class="dash">-</span>
                <input v-model="code[3]" maxlength="1" class="otp-box" @input="focusNext(3,$event)">
                </div>
            </CContainer>

            <div class="btn-fixed">
                <CButton block class="custom-border-purple" color="primary"
                        :disabled="code.join('').length!==4 || lblProcess"
                        @click="submitVerification">
                {{ lblProcess ? 'Verifying…' : 'Verify' }}
                </CButton>
            </div>
        </div>

    
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Your account is succesfully registered</h3>
                    <CButton class="custom-border-purple text-white" @click="closePopup"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
    
            </div>
        </div>
    
    
    </div>
</template>

<script>
import Vue from "vue";



import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgsecond.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            email: this.$route.query.email || "",
            code: ["", "", "", ""],

            lblProcess: false,

            // mobile extras
            timeLeft: 90,   // seconds for countdown
            timerId: null,



        };
    },

    computed:{
        maskedEmail(){
            const e = this.email || "";
            const [u, d] = e.split("@");
            if(!u || !d) return e;
            const shown = u.slice(0,2);
            return `${shown}${"x".repeat(Math.max(0,u.length-2))}@${d}`;
        },
        mm(){ return String(Math.floor(this.timeLeft/60)).padStart(2,"0"); },
        ss(){ return String(this.timeLeft%60).padStart(2,"0"); },
        },
        mounted(){
        this.timerId = setInterval(()=>{ if(this.timeLeft>0) this.timeLeft--; },1000);
        },
        beforeDestroy(){
        if(this.timerId) clearInterval(this.timerId);
    },


    methods: {
        focusNext(i, e){
            const v = (e.target.value||"").replace(/\D/g,"").slice(0,1);
            this.$set(this.code, i, v);
            if(v && i < 3) e.target
            .closest(".otp-row")
            .querySelectorAll(".otp-box")[i+1]
            .focus();
            if(i===3 && this.code.join("").length===4) {
            // optional: auto-submit
            // this.submitVerification();
            }
        },
        onPaste(e){
            const digits = (e.clipboardData.getData("text")||"").replace(/\D/g,"").slice(0,4).split("");
            for(let i=0;i<4;i++) this.$set(this.code, i, digits[i]||"");
        },

        submitVerification() {
            const verificationCode = this.code.join("");
            if (verificationCode.length !== 4) return; // guard
            this.ValidateCode(verificationCode);
        },

        ValidateCode(verificationCode) {
            this.lblProcess = true;
            this.ErrorMessage = false;
            this.Error = false;
            this.Message = "";

            const formData = new FormData();
            formData.append("userEmail", this.email);   // use data() value
            formData.append("code", verificationCode);

            return this.$API
            .post(this.$ValidateForgotPasswordCode, formData, { withCredentials: true })
            .then((response) => {
                if (response.status === 200 && Number(response.data) > 0) {
                // use named route if available; otherwise keep path string
                this.$router.push({ name: "ResetPassword", query: { email: this.email, code: verificationCode } });
                // or: this.$router.push(`/ResetPassword?email=${encodeURIComponent(this.email)}&code=${verificationCode}`);
                } else {
                this.ErrorMessage = true;
                this.Message = "Invalid code. Please try again.";
                }
            })
            .catch((error) => {
                this.Error = true;
                this.Message = error?.response?.data?.message || "Network error.";
                this.ErrorMessage = true;
            })
            .finally(() => {
                this.lblProcess = false;
            });
        },



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.enter-otp{
    font-size: 18px;
    font-weight: 500;
    color: #171717;
}
.otp-container {
  text-align: center;
  padding: 20px;
}

.otp-row{ display:flex; align-items:center; justify-content: center; gap:12px; margin: 12px 0 8px; }
.otp-box{
  width:56px; height:56px; border-radius:14px; border:1px solid #e5e7eb;
  text-align:center; font-size:28px; font-weight:600; outline:none;
}
.dash{ font-size:28px; color:#6b7280; }

</style>